import type { IconProps } from '../types/IconProps.ts';
export const Link2: IconProps = {
    name: 'Link2',
    children: [
        `<path d="M8 7H7a5 5 0 0 0 0 10h1m8-10h1a5 5 0 0 1 0 10h-1M7 12h9" />`,
    ]
};